export default theme => ({
  root: {},
  action: {
    margin: '10px 0 10px 10px'
  },
  conditionString: {
    marginLeft: 5,
    color: theme.colors.primary.black,
    wordBreak: 'break-word'
  },
  conditionStringContainer: {
    display: 'flex',
    alignItems: 'center',
    border: `1px solid ${theme.colors.grey[100]}`,
    padding: '10px',
    background: `${theme.colors.actionMinor[50]}`,
    '& svg': {
      width: 18,
      height: 18
    }
  },
  groupSeparator: {
    padding: '10px 0',
    borderLeft: `1px solid ${theme.colors.grey[100]}`
  }
});